/**
 * O ambiente que vem do banco, conferido antes de virar selo.
 *
 * `EnvironmentBadge` recebe `FiscalEnvironment` — a união fechada do domínio,
 * `production | homologation`. As linhas vêm do PostgREST como `string`, porque
 * é isso que o SDK sabe dizer sem esquema gerado.
 *
 * O ATALHO QUE NÃO SE TOMA AQUI
 *
 *   `environment as FiscalEnvironment` compilaria e estaria errado. Um valor
 *   inesperado viraria uma classe CSS inexistente e um selo sem cor — e o selo
 *   de ambiente é o que impede confundir homologação com produção, que é um dos
 *   incidentes que o 2.0 nasce para não repetir.
 *
 *   Então a conferência é real, e o que não passa por ela aparece como
 *   desconhecido, escrito. Um ambiente que ninguém reconhece é informação; um
 *   ambiente adivinhado é risco.
 */

import { FISCAL_ENVIRONMENTS, type FiscalEnvironment } from '@optefiscal/fiscal-domain';

export function asFiscalEnvironment(valor: string): FiscalEnvironment | null {
  return (FISCAL_ENVIRONMENTS as readonly string[]).includes(valor)
    ? (valor as FiscalEnvironment)
    : null;
}
